import {Component, OnDestroy, OnInit, ViewChild, Output, EventEmitter, Input} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
// removed legacy rxjs-compat operator import
import {PaginationInstance} from "ngx-pagination";
import {UserVerificationService} from "../services/user-verification.service";
import {KeycloakService} from "../services/keycloak.service";
import { Subscription } from 'rxjs';
import {NgForm} from "@angular/forms";
import {HttpService} from "../services/http.service";
import {ApiEndpoints} from "../services/api-endpoints";
import {StringUtils} from "../services/string-utils";
import {flatMap, map, tap} from 'rxjs/operators';

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-served-network-servers',
  templateUrl:'./served-network-servers.component.html',
})
export class ServedNetworkServersComponent implements OnInit, OnDestroy {

  isAdmin: boolean = false;
  username: string = KeycloakService.username;
  canAddServedNetworkServers: boolean;

  listServedNetworkServers: any[];

  isAdminSubscription: Subscription;
  httpSubscription: Subscription;

  public inputKeywordServedNetworkServerSearch = "";
  public optionServedNetworkServerSearch = "Search Type";

  public servedNetworkServersRefreshing = false;

  configPagerServedNetworkServers: PaginationInstance = {
    id: 'served-network-servers-list',
    currentPage: 1,
    itemsPerPage: 5,
  };

  @Input() virtId: string;
  @Input() joinEUIs: string[];
  @Input() name: string;
  @Output() servedNetworkServersLoadedEvent = new EventEmitter<any[]>();
  constructor(private route: ActivatedRoute,
              private http: HttpClient,
              private router: Router,
              private userVerificationService: UserVerificationService,
              private httpService: HttpService) {

    this.isAdmin = this.userVerificationService.isAdmin;
  }

  createActivationAgreement(name, id, virtId) {
    this.router.navigate(['./add-served-network-server'], {queryParams: {name, id, virtId}});
  }

  editActivationAgreement(nsId, jsId, nsName, jsName, netIds, joinEuis) {
    this.router.navigate(['/edit-activation-agreement'], {
      queryParams: {
        nsId,
        jsId,
        nsName,
        jsName,
        netIds,
        joinEuis
      }
    });
  }

  getAllNetworkServerWithoutActivationAgreement(virtId){
    var url = ApiEndpoints.GET_ALL_NETWORK_SERVERS_WOA;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    var body = {
      "virtID" : virtId
    };

    this.http.post<Array<any>>(url, body, options).subscribe(
        data => {
          this.canAddServedNetworkServers = data.length != 0;
        }
      );
  }

  ServedNetworkServers(id) {
    var body: any = {"virtId": id};
    var url = ApiEndpoints.GET_SERVED_NETWORK_SERVERS;
    const headers = new HttpHeaders({
          'Content-Type': 'application/json'
    });
    let options =  {headers: headers};
    this.servedNetworkServersRefreshing = true;
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.listServedNetworkServers = this.parseServedNetworkServersList(data);
          this.servedNetworkServersLoadedEvent.emit(this.listServedNetworkServers);
          this.servedNetworkServersRefreshing = false;
        }
      );
  }

  ServedNetworkSearch(vIdSearch, urlSearch, filterSearch, keywordSearch) {
    if (filterSearch == "Name") {
      var body: any = {"virtId": vIdSearch, "name": keywordSearch};
      var url = urlSearch;
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      let options =  {headers: headers};
      this.servedNetworkServersRefreshing = true;
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.listServedNetworkServers = this.parseServedNetworkServersList(data)
            this.servedNetworkServersLoadedEvent.emit(this.listServedNetworkServers);
            this.servedNetworkServersRefreshing = false;
          }
        );
    }
    if (filterSearch == "NetID") {
      var body: any = {"virtId": vIdSearch, "netId": keywordSearch};
      var url = urlSearch;
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      let options =  {headers: headers};
      this.servedNetworkServersRefreshing = true;
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.listServedNetworkServers = this.parseServedNetworkServersList(data)
            this.servedNetworkServersLoadedEvent.emit(this.listServedNetworkServers);
            this.servedNetworkServersRefreshing = false;
          }
        );
    }
    if(filterSearch == 'Search Type'){
      this.ServedNetworkServers(this.virtId)
    }
  }

  refreshServedNetworkServers(){
    var urlSearch = ApiEndpoints.GET_SERVED_NETWORK_SERVERS
    this.ServedNetworkSearch(this.virtId, urlSearch, this.optionServedNetworkServerSearch, this.inputKeywordServedNetworkServerSearch);
  }

  insertSpacesBetweenIds(ids: Array<string>) {
    return StringUtils.insertSpacesBetweenIds(ids);
  }

  parseServedNetworkServersList(listServedNetworkServers) {
    listServedNetworkServers.forEach(servedNetworkServer => {
      servedNetworkServer.netIds = this.insertSpacesBetweenIds(servedNetworkServer.netIds);
    });
    return listServedNetworkServers;
  }

  resetPager() {
      this.configPagerServedNetworkServers.currentPage = 1;
  }

  onKeywordSearch(event: KeyboardEvent) {
    var urlSearch = ApiEndpoints.GET_SERVED_NETWORK_SERVERS;
    if (event.keyCode === 13) {
      this.ServedNetworkSearch(this.virtId, urlSearch, this.optionServedNetworkServerSearch, this.inputKeywordServedNetworkServerSearch);
    }
  }

  onOptionServedNetworkServerSearchChanged(event) {
    const value = event.target.value;
    this.inputKeywordServedNetworkServerSearch = "";
  }

  ngOnInit() {
    this.ServedNetworkServers(this.virtId);
    this.getAllNetworkServerWithoutActivationAgreement(this.virtId)

    $('.table-filter-search').selectpicker({
      liveSearch: true,
      maxOptions: 1
    });
  }

  ngOnDestroy() {

  }

}
